<div class="At-Wrapper">
    <section class="At-SectionLogin">
        <div class="container-fluid p-0">
            <div class="row no-gutters">
                <div class="col-md-5 at_Mainlogin At-CustomCol-47 d-flex align-items-center justify-content-center">
                    <div class="At-LoginFormGeneral">
                        <a class="At-BtnBack At-BtnLinkBlue" (click)="backClicked()" href="javascript:void(0);">
                            <i class="icon-back-arrow"></i> <h5>BACK</h5>
                        </a>
                        <div class="At-ImgHolder At-ImgHolderLoginLogo">
                            <i class="icon-logo"></i>
                        </div>
                        <h2>Reset Password</h2>
                        <h5>Enter new password for your Komunikasi account</h5>
                        <div class="At-forgotContent">
                        </div>   
                        <form class="At-FormForgot">
                            <div class="form-group ">
                                <div class="At-Input">
                                    <input type="password" class="form-control" id="idPassword"  placeholder="Enter New Password">
                                </div>
                            </div>
                            <div class="form-group ">
                                <div class="At-Input">
                                    <input type="password" class="form-control" id="idPassword"  placeholder="Confirm New Password">
                                </div>
                            </div>
                            <div class="form-group">
                                <button class="At-Btn" routerLink="/verify-email">SUBMIT </button>
                            </div>
                        </form>
                    </div>
                </div>
                <!-- at_Mainlogin ends -->

                <div class="col-md-7 At-BannerLogin  At-CustomCol-53 d-flex align-items-center justify-content-center">
                    <div class="At-ImgHolder">
                        <figure>
                            <img src="assets/images/reset-right-bg.png" class="img-fluid" alt="">
                        </figure>
                    </div>
                    <a class="At-GetMobileAppLink" href="#">GET YOUR MOBILE APP   >></a>
                </div>
                <!-- At-BannerLogin ends -->
            </div>
        </div>
    </section>
</div> 